import { c as _c } from "react/compiler-runtime";
import { FormInput, Popover, toast } from '@systemeio/ui';
import { BLOGS_API, createCategory, deleteCategory, updateCategory } from 'modules/blogs/api/blog-api';
import { useBlogCategories } from 'modules/blogs/hooks/use-blog-categories';
import { BlogCategoriesCreateInterface, BlogCategoriesEditInterface, BlogCategoriesInterface } from 'modules/blogs/types/blog-categories-interface';
import { BlogInterface } from 'modules/blogs/types/blog-interface';
import React, { useState } from 'react';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { buildPath } from 'shared/utils/build-path';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { QuestionMarkIcon } from '@systemeio/ui/icons';
interface BlogPagesProps {
  blog?: BlogInterface;
  blogId: string;
}
const defaultValues: BlogCategoriesCreateInterface = {
  name: '',
  path: '',
  description: '',
  seoDescription: '',
  seoTitle: ''
};
const defaultErrors: BlogCategoriesEditInterface = {
  name: '',
  path: '',
  seoDescription: '',
  description: '',
  seoTitle: ''
};
const BlogCategories = t0 => {
  const $ = _c(132);
  const {
    blog,
    blogId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination(true);
  const t1 = blogId as string;
  let t2;
  if ($[0] !== limit || $[1] !== pagination || $[2] !== t1) {
    t2 = {
      limit,
      pagination,
      id: t1
    };
    $[0] = limit;
    $[1] = pagination;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    blogCategories,
    blogCategoriesMutate,
    blogCategoriesCounter
  } = useBlogCategories(t2);
  const t3 = `${BLOGS_API}/${blogId}/categories`;
  let t4;
  if ($[4] !== setPagination || $[5] !== t3) {
    t4 = {
      api: t3,
      setPagination
    };
    $[4] = setPagination;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const updateData = useUpdateData(t4);
  const [errors, setErrors] = useState(defaultErrors);
  let t5;
  if ($[7] !== blog || $[8] !== blogCategories || $[9] !== t || $[10] !== updateData) {
    t5 = async data => {
      ;
      try {
        await fetchWithErrors(async () => {
          if (blog) {
            const newData = {
              name: data.name,
              path: data.path,
              description: data.description || "",
              seoTitle: data.seoTitle || "",
              seoDescription: data.seoDescription || ""
            };
            await createCategory(blog?.id, newData);
            await updateData(true, blogCategories);
          }
        }, setErrors);
        toast.success(t("dashboard.blog.categories.created"));
      } catch (t6) {
        const e = t6;
        throw e;
      }
    };
    $[7] = blog;
    $[8] = blogCategories;
    $[9] = t;
    $[10] = updateData;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const onCreate = t5;
  let t6;
  if ($[12] !== blog || $[13] !== blogCategories || $[14] !== blogCategoriesMutate || $[15] !== updateData) {
    t6 = async (category, data_0) => {
      ;
      try {
        await fetchWithErrors(async () => {
          if (blog) {
            const newData_0 = {
              name: data_0.name,
              path: data_0.path,
              seoDescription: data_0.seoDescription || "",
              seoTitle: data_0.seoTitle || "",
              description: data_0.description || ""
            };
            const response = await updateCategory(category?.id, newData_0);
            await updateData(false, undefined, {
              mutationData: blogCategories,
              onMutate: async () => {
                await blogCategoriesMutate(data_1 => {
                  if (data_1) {
                    return {
                      ...data_1,
                      items: data_1.items.map(el => {
                        if (el.id === category.id) {
                          return {
                            ...response.data
                          };
                        } else {
                          return el;
                        }
                      })
                    };
                  }
                }, false);
              }
            });
          }
        }, setErrors);
      } catch (t7) {
        const e_0 = t7;
        throw e_0;
      }
    };
    $[12] = blog;
    $[13] = blogCategories;
    $[14] = blogCategoriesMutate;
    $[15] = updateData;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const onEdit = t6;
  let t7;
  if ($[17] !== blogCategories || $[18] !== updateData) {
    t7 = async data_2 => {
      ;
      try {
        await deleteCategory(data_2.id);
        await updateData(false, blogCategories);
      } catch (t8) {
        const e_1 = t8;
        throw e_1;
      }
    };
    $[17] = blogCategories;
    $[18] = updateData;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const onRemove = t7;
  let t8;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setErrors(defaultErrors);
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const onModalClose = t8;
  let t9;
  if ($[21] !== t) {
    t9 = t("global.title");
    $[21] = t;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = {
      key: "name",
      header: t9,
      widthPercent: 30
    };
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== t) {
    t11 = t("dashboard.blog.categories.title");
    $[25] = t;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11) {
    t12 = {
      key: "path",
      widthPercent: 30,
      header: t11,
      onRender: _temp
    };
    $[27] = t11;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t) {
    t13 = t("dashboard.blog.categories.total_blog_posts");
    $[29] = t;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13) {
    t14 = {
      key: "postsCount",
      widthPercent: 10,
      header: t13
    };
    $[31] = t13;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== t) {
    t15 = t("global.created_on");
    $[33] = t;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== user?.dateFormat || $[36] !== user?.timeFormat || $[37] !== user?.timezone) {
    t16 = blogCategory_0 => <span>{dateTimeFormat(blogCategory_0.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[35] = user?.dateFormat;
    $[36] = user?.timeFormat;
    $[37] = user?.timezone;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t15 || $[40] !== t16) {
    t17 = {
      key: "createdAt",
      header: t15,
      widthPercent: 30,
      onRender: t16
    };
    $[39] = t15;
    $[40] = t16;
    $[41] = t17;
  } else {
    t17 = $[41];
  }
  let t18;
  if ($[42] !== t10 || $[43] !== t12 || $[44] !== t14 || $[45] !== t17) {
    t18 = [t10, t12, t14, t17];
    $[42] = t10;
    $[43] = t12;
    $[44] = t14;
    $[45] = t17;
    $[46] = t18;
  } else {
    t18 = $[46];
  }
  const columns = t18;
  let t19;
  if ($[47] !== t) {
    t19 = t("dashboard.blog.categories.title_plural");
    $[47] = t;
    $[48] = t19;
  } else {
    t19 = $[48];
  }
  let t20;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = ["name", "path"];
    $[49] = t20;
  } else {
    t20 = $[49];
  }
  let t21;
  if ($[50] !== t) {
    t21 = t("dashboard.blog.categories.create_new_category");
    $[50] = t;
    $[51] = t21;
  } else {
    t21 = $[51];
  }
  let t22;
  if ($[52] !== errors || $[53] !== t) {
    t22 = {
      field: "name",
      onRender: (value, onChange, state, onChangeState) => <FormInput required={true} key="name-create" value={value} onChange={e_2 => onChangeState({
        ...state,
        name: e_2.target.value,
        path: buildPath(e_2.target.value)
      })} label={t("global.title")} error={errors.name} />
    };
    $[52] = errors;
    $[53] = t;
    $[54] = t22;
  } else {
    t22 = $[54];
  }
  let t23;
  if ($[55] !== errors || $[56] !== t) {
    t23 = {
      field: "path",
      onRender: (value_0, onChange_0) => <FormInput required={true} key="path-create" label={t("dashboard.blog.categories.path")} value={value_0} onChange={e_3 => onChange_0(e_3.target.value)} error={errors.path} />
    };
    $[55] = errors;
    $[56] = t;
    $[57] = t23;
  } else {
    t23 = $[57];
  }
  let t24;
  if ($[58] !== errors || $[59] !== t) {
    t24 = {
      field: "description",
      onRender: (value_1, onChange_1) => <FormInput key="description-create" label={t("global.description")} value={value_1 || ""} onChange={e_4 => onChange_1(e_4.target.value)} error={errors.description} />
    };
    $[58] = errors;
    $[59] = t;
    $[60] = t24;
  } else {
    t24 = $[60];
  }
  let t25;
  if ($[61] !== errors || $[62] !== t) {
    t25 = {
      field: "seoTitle",
      onRender: (value_2, onChange_2) => <FormInput key="seo-title-create" label={<div className="flex items-center gap-1">Seo title<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.categories.seo_title_description")}>{_temp2}</Popover></div>} value={value_2 || ""} onChange={e_5 => onChange_2(e_5.target.value)} error={errors.seoTitle} />
    };
    $[61] = errors;
    $[62] = t;
    $[63] = t25;
  } else {
    t25 = $[63];
  }
  let t26;
  if ($[64] !== errors || $[65] !== t) {
    t26 = {
      field: "seoDescription",
      onRender: (value_3, onChange_3) => <FormInput key="seo-description-create" label={<div className="flex items-center gap-1">Seo description<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.categories.seo_description_description")}>{_temp3}</Popover></div>} value={value_3 || ""} onChange={e_6 => onChange_3(e_6.target.value)} error={errors.seoDescription} />
    };
    $[64] = errors;
    $[65] = t;
    $[66] = t26;
  } else {
    t26 = $[66];
  }
  let t27;
  if ($[67] !== t22 || $[68] !== t23 || $[69] !== t24 || $[70] !== t25 || $[71] !== t26) {
    t27 = [t22, t23, t24, t25, t26];
    $[67] = t22;
    $[68] = t23;
    $[69] = t24;
    $[70] = t25;
    $[71] = t26;
    $[72] = t27;
  } else {
    t27 = $[72];
  }
  let t28;
  if ($[73] !== onCreate || $[74] !== t21 || $[75] !== t27) {
    t28 = {
      onCreate,
      onAfterLeave: onModalClose,
      requiredFields: t20,
      fullCaption: t21,
      needToast: false,
      defaultValues,
      creatable: t27
    };
    $[73] = onCreate;
    $[74] = t21;
    $[75] = t27;
    $[76] = t28;
  } else {
    t28 = $[76];
  }
  let t29;
  if ($[77] !== t) {
    t29 = t("dashboard.blog.categories.title");
    $[77] = t;
    $[78] = t29;
  } else {
    t29 = $[78];
  }
  let t30;
  if ($[79] !== onEdit) {
    t30 = (instance, data_3) => onEdit(instance, data_3);
    $[79] = onEdit;
    $[80] = t30;
  } else {
    t30 = $[80];
  }
  let t31;
  if ($[81] !== t) {
    t31 = t("dashboard.blog.categories.edit_categories");
    $[81] = t;
    $[82] = t31;
  } else {
    t31 = $[82];
  }
  let t32;
  if ($[83] !== errors || $[84] !== t) {
    t32 = {
      field: "name",
      onRender: (value_4, onChange_4, state_0, _, __, onChangeState_0) => <FormInput required={true} key="name-create" value={value_4} onChange={e_7 => {
        onChangeState_0({
          ...state_0,
          name: e_7.target.value,
          path: e_7.target.value.replaceAll(" ", "-").replace(/[^a-zA-Z|\-_\d+]/g, "").toLowerCase()
        });
      }} label={t("global.title")} error={errors.name} />
    };
    $[83] = errors;
    $[84] = t;
    $[85] = t32;
  } else {
    t32 = $[85];
  }
  let t33;
  if ($[86] !== errors || $[87] !== t) {
    t33 = {
      field: "path",
      onRender: (value_5, onChange_5) => <FormInput required={true} key="path-create" label={t("dashboard.blog.categories.path")} value={value_5} onChange={e_8 => onChange_5(e_8.target.value)} error={errors.path} />
    };
    $[86] = errors;
    $[87] = t;
    $[88] = t33;
  } else {
    t33 = $[88];
  }
  let t34;
  if ($[89] !== errors || $[90] !== t) {
    t34 = {
      field: "description",
      onRender: (value_6, onChange_6) => <FormInput key="description-create" label={t("global.description")} value={value_6 || ""} onChange={e_9 => onChange_6(e_9.target.value)} error={errors.description} />
    };
    $[89] = errors;
    $[90] = t;
    $[91] = t34;
  } else {
    t34 = $[91];
  }
  let t35;
  if ($[92] !== errors || $[93] !== t) {
    t35 = {
      field: "seoTitle",
      onRender: (value_7, onChange_7) => <FormInput key="seo-title-create" label={<div className="flex items-center gap-1">Seo title<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.categories.seo_title_description")}>{_temp4}</Popover></div>} value={value_7 || ""} onChange={e_10 => onChange_7(e_10.target.value)} error={errors.seoTitle} />
    };
    $[92] = errors;
    $[93] = t;
    $[94] = t35;
  } else {
    t35 = $[94];
  }
  let t36;
  if ($[95] !== errors || $[96] !== t) {
    t36 = {
      field: "seoDescription",
      onRender: (value_8, onChange_8) => <FormInput key="seo-description-create" label={<div className="flex items-center gap-1">Seo description<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.blog.categories.seo_description_description")}>{_temp5}</Popover></div>} value={value_8 || ""} onChange={e_11 => onChange_8(e_11.target.value)} error={errors.seoDescription} />
    };
    $[95] = errors;
    $[96] = t;
    $[97] = t36;
  } else {
    t36 = $[97];
  }
  let t37;
  if ($[98] !== t32 || $[99] !== t33 || $[100] !== t34 || $[101] !== t35 || $[102] !== t36) {
    t37 = [t32, t33, t34, t35, t36];
    $[98] = t32;
    $[99] = t33;
    $[100] = t34;
    $[101] = t35;
    $[102] = t36;
    $[103] = t37;
  } else {
    t37 = $[103];
  }
  let t38;
  if ($[104] !== t30 || $[105] !== t31 || $[106] !== t37) {
    t38 = {
      onEdit: t30,
      onModalClose,
      fullCaption: t31,
      editable: t37
    };
    $[104] = t30;
    $[105] = t31;
    $[106] = t37;
    $[107] = t38;
  } else {
    t38 = $[107];
  }
  let t39;
  if ($[108] !== onRemove) {
    t39 = {
      onChange: onRemove
    };
    $[108] = onRemove;
    $[109] = t39;
  } else {
    t39 = $[109];
  }
  let t40;
  if ($[110] !== t38 || $[111] !== t39) {
    t40 = {
      settings: t38,
      remove: t39
    };
    $[110] = t38;
    $[111] = t39;
    $[112] = t40;
  } else {
    t40 = $[112];
  }
  let t41;
  if ($[113] !== limit || $[114] !== setLimit) {
    t41 = {
      limit,
      setLimit
    };
    $[113] = limit;
    $[114] = setLimit;
    $[115] = t41;
  } else {
    t41 = $[115];
  }
  let t42;
  if ($[116] !== pagination || $[117] !== setPagination) {
    t42 = {
      pagination,
      setPagination
    };
    $[116] = pagination;
    $[117] = setPagination;
    $[118] = t42;
  } else {
    t42 = $[118];
  }
  let t43;
  if ($[119] !== blogCategories || $[120] !== columns || $[121] !== t29 || $[122] !== t40 || $[123] !== t41 || $[124] !== t42) {
    t43 = <Table caption={t29} actions={t40} data={blogCategories} columns={columns} limiter={t41} paginator={t42} />;
    $[119] = blogCategories;
    $[120] = columns;
    $[121] = t29;
    $[122] = t40;
    $[123] = t41;
    $[124] = t42;
    $[125] = t43;
  } else {
    t43 = $[125];
  }
  let t44;
  if ($[126] !== blogCategories || $[127] !== blogCategoriesCounter || $[128] !== t19 || $[129] !== t28 || $[130] !== t43) {
    t44 = <ListingLayout title={t19} counter={blogCategoriesCounter} data={blogCategories} type="compact" createData={t28}>{t43}</ListingLayout>;
    $[126] = blogCategories;
    $[127] = blogCategoriesCounter;
    $[128] = t19;
    $[129] = t28;
    $[130] = t43;
    $[131] = t44;
  } else {
    t44 = $[131];
  }
  return t44;
};
export default BlogCategories;
function _temp(blogCategory) {
  return <div className="truncate"><a rel="noreferrer" className="primary-link w-full" href={blogCategory.viewUrl}>{blogCategory.path}</a></div>;
}
function _temp2(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp3(show_0) {
  return <QuestionMarkIcon className={`${show_0 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp4(show_1) {
  return <QuestionMarkIcon className={`${show_1 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp5(show_2) {
  return <QuestionMarkIcon className={`${show_2 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}